import { render, staticRenderFns } from "./InterviewCandidateList.vue?vue&type=template&id=edb91270&scoped=true&"
import script from "./InterviewCandidateList.vue?vue&type=script&lang=js&"
export * from "./InterviewCandidateList.vue?vue&type=script&lang=js&"
import style0 from "./InterviewCandidateList.vue?vue&type=style&index=0&id=edb91270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb91270",
  null
  
)

export default component.exports